<template>
  <aside class="main-sidebar">
    <section class="sidebar">
      <sidebar-menu />
    </section>
  </aside>
</template>
<script>
import SidebarMenu from './SidebarMenu'

export default {
  name: 'Sidebar',
  components: { SidebarMenu }
}
</script>
<style scope="local">
.user-panel .image img {
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// Sidebar.vue?5763feeb